var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClozeQuestion = function SvgClozeQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 134",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 0 1 5-5h130a5 5 0 0 1 5 5v110a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 0 1 5-5h130a5 5 0 0 1 5 5v110a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 124,
    height: 89,
    rx: 1.579,
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M26 45.5h32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 40.5,
    width: 24,
    height: 10,
    rx: 1.579,
    stroke: "#4C6EF5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M96 45.5h32M26 58.5h102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 70.5 2 2 2-2",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.579,
    stroke: "#4C6EF5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M57 71.5h71M26 84.5h102M26 97.5h32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69 96.5 2 2 2-2",
    stroke: "#4C6EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 92.5,
    width: 24,
    height: 10,
    rx: 1.579,
    stroke: "#4C6EF5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M96 97.5h32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.611 14.611-5 24-5h106c9.389 0 17 7.611 17 17v7H7v-7Zm140 115H7h140ZM7 127V7v120ZM147 7v120V7Z",
    fill: "#343A40",
    mask: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5797_36959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5797_36959",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClozeQuestion);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";